/*
 * Copyright (c) 2022 biocrates life sciences ag, All rights reserved.
 */

import {getModuleSpecificActions} from "../../../@biocrates-common-repo/settings/actions/settings.actions"
import {GeneralSettings, State} from "../reducers/settings.state"

// General

// eslint-disable-next-line import/prefer-default-export
export const generalSettingsActions = getModuleSpecificActions<
    State,
    GeneralSettings
>("general")
